module.exports = __webpack_public_path__ + "static/img/planet.c8ea329f.png";